import React from 'react';
import { motion } from 'framer-motion';

interface NotificationSkeletonProps {
  count?: number;
}

const NotificationSkeleton: React.FC<NotificationSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="divide-y divide-white/10">
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          className="relative p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 }}
        >
          {/* Blue Dot Skeleton - top-left */}
          <div className="absolute top-2 left-2 w-2 h-2 bg-blue-400/30 rounded-full animate-pulse" />
          
          {/* Dismiss Button Skeleton - top-right */}
          <div className="absolute top-2 right-2 w-5 h-5 bg-white/5 rounded animate-pulse" />
          
          <div className="flex items-start space-x-3">
            {/* Icon Column Skeleton - Stacked Vertically */}
            <div className="flex flex-col space-y-2 flex-shrink-0 w-7 items-center justify-center">
              <div className="w-6 h-6 rounded-full bg-white/10 animate-pulse" />
              <div className="w-7 h-7 rounded-lg bg-white/5 animate-pulse" />
            </div>
            
            {/* Content Skeleton - Full width */}
            <div className="flex-1 min-w-0">
              <div className="flex flex-col">
                <div className="flex-1 min-w-0 space-y-2">
                  {/* Title Skeleton */}
                  <div className="h-4 bg-white/10 rounded animate-pulse w-3/4" />
                  
                  {/* Message Skeleton */}
                  <div className="h-3 bg-white/5 rounded animate-pulse w-full" />
                  
                  {/* Metadata Skeleton */}
                  <div className="flex items-center space-x-2">
                    <div className="h-2 bg-white/5 rounded animate-pulse w-16" />
                    <div className="w-1 h-1 bg-white/20 rounded-full" />
                    <div className="h-2 bg-white/5 rounded animate-pulse w-12" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default NotificationSkeleton;